/*
 * Copyright (c) 2026 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { PageQueryParams } from '../api/apiCommon.typings';
import { createAction } from '../../utils/redux-utils';
import { Notification, NOTIFICATION_TYPES } from '../../utils/utils';
import { i18n } from '../translation/i18n';
import { CashRegistersListDto, CashRegistersListFilterParams } from 'data/api/cashRegister/cashRegistersClient.typings';

export enum CashRegistersListActionType {
    OPEN_REGISTRY_CASH_REGISTERS_LIST_PAGE = 'RegistryCashRegistersList/ open page',
    EXIT_REGISTRY_CASH_REGISTERS_LIST_PAGE = 'RegistryCashRegistersList/ exit page',

    APPLY_PAGING = 'RegistryCashRegistersList/ apply paging',
    APPLY_FILTERS = 'RegistryCashRegistersList/ apply filters',

    CHANGE_FILTERS = 'RegistryCashRegistersList/ change filters',

    FETCH_CASH_REGISTERS_LIST_SUCCESS = 'RegistryCashRegistersList/ fetch cash registers list success',
    FETCH_CASH_REGISTERS_LIST_ERROR = 'RegistryCashRegistersList/ fetch cash registers list error',
}

export const openRegistryCashRegistersListAction = () =>
    createAction(CashRegistersListActionType.OPEN_REGISTRY_CASH_REGISTERS_LIST_PAGE);

export const exitRegistryCashRegistersListAction = () =>
    createAction(CashRegistersListActionType.EXIT_REGISTRY_CASH_REGISTERS_LIST_PAGE);

export const applyPagingAction = (params: PageQueryParams) =>
    createAction(CashRegistersListActionType.APPLY_PAGING, params);

export const applyFilteringAction = () => createAction(CashRegistersListActionType.APPLY_FILTERS);

export const changeFiltersAction = (params: CashRegistersListFilterParams) =>
    createAction(CashRegistersListActionType.CHANGE_FILTERS, params);

export const fetchCashRegistersListSuccessAction = (list: CashRegistersListDto) =>
    createAction(CashRegistersListActionType.FETCH_CASH_REGISTERS_LIST_SUCCESS, {
        list,
        notification:
            list.count === 0
                ? {
                      type: NOTIFICATION_TYPES[1],
                      message: i18n.t('errors.notFoundByParams'),
                  }
                : null,
    });

export const fetchCashRegistersListErrorAction = (notification: Notification) =>
    createAction(CashRegistersListActionType.FETCH_CASH_REGISTERS_LIST_ERROR, { notification });

export type CashRegistersListAction =
    | ReturnType<typeof openRegistryCashRegistersListAction>
    | ReturnType<typeof exitRegistryCashRegistersListAction>
    | ReturnType<typeof applyPagingAction>
    | ReturnType<typeof applyFilteringAction>
    | ReturnType<typeof changeFiltersAction>
    | ReturnType<typeof fetchCashRegistersListSuccessAction>
    | ReturnType<typeof fetchCashRegistersListErrorAction>;
